import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import ModalFooter from 'CommonComponents/ModalFooter';
import TextareaFormField from 'CommonComponents/TextareaFormField';
import TextFormField from 'CommonComponents/TextFormField';

const CategoryEditSchema = Yup.object().shape({
    name: Yup.string().required('This value is required'),
    info: Yup.string(),
});

export default function MarkUpCategoryForm(props) {
    return (
        <Formik
            initialValues={{
                name: props.category.name || '',
                info: props.category.info || '',
            }}
            validationSchema={CategoryEditSchema}
            onSubmit={(values, actions) => {
                let url = props.updateUrl;
                if (props.action === 'update') {
                    const categoryId = props.category.id || '';
                    url = url.replace('CATEGORY_ID', categoryId);
                }

                axios({
                    method: props.action === 'update' ? 'put' : 'post',
                    url: url,
                    data: values,
                })
                    .then((response) => {
                        props.setCategoryIsUpdated(true);
                        actions.resetForm();
                    })
                    .catch((e) => {
                        actions.setErrors(e.response.data.errors);
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                    });
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField
                            label={$t('Category Name')}
                            type="text"
                            required={true}
                            name="name"
                            placeholder={$t('Enter category name')}
                        ></TextFormField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <TextareaFormField
                            label={$t('Additional Info')}
                            as="textarea"
                            type="text"
                            name="info"
                            placeholder={$t('Enter additional info')}
                        ></TextareaFormField>
                    </div>

                    <ModalFooter
                        cancelButtonText={$t('Cancel')}
                        primaryButtonText={props.action === 'update' ? 'Update' : 'Save'}
                        onCancel={props.internalCloseHandler}
                        handleSubmit={handleSubmit}
                        isSubmitting={props.request}
                        submitButtonVariant={'primary'}
                    ></ModalFooter>
                </>
            )}
        </Formik>
    );
}
